<template>
  <div>
    <div class="el_tabs">
      <button type="button" :class="selectedLanguage === 'en' ? 'active' : ''" @click="$emit('onSelectedLanguage', 'en')">
        <img src="/assets/en_lang_invite.svg" width="24" :alt="adminText('workflowsAll.english_649df08', 'English')">
        {{ adminText('workflowsAll.english_649df08', 'English') }}
      </button>
      <button type="button" :class="selectedLanguage === 'hr' ? 'active' : ''" @click="$emit('onSelectedLanguage', 'hr')">
        <img src="/assets/hr_lang_invite.svg" width="24" :alt="adminText('workflowsAll.croatian_3e5488a', 'Croatian')">
        {{ adminText('workflowsAll.croatian_3e5488a', 'Croatian') }}
      </button>
    </div>
    <div class="el_card">
      <p>
        {{ workflowLabel(workflowCustomerLabel('invitePageLinkDescription', {}, $t('invitePageLinkDescription'))) }}
      </p>
      <div class="copy">
        <div class="link_icon_container">
          <v-icon class="copy_icon" :style="{color: inviteUrl.length || disabled ? '#0277BD' : '#979797'}">
            link
          </v-icon>
        </div>
        <div class="truncate" :title="workflowLabel(inviteUrl)">
          {{ workflowLabel(inviteUrl) }}
        </div>
        <div>
          <button
            v-clipboard:copy="inviteUrl"
            type="button"
            :style="{color: inviteUrl.length || disabled ? '#0277BD' : '#979797'}"
            :disabled="!inviteUrl.length || disabled"
            @click="openSnackbar"
          >
            <span>
              <v-icon class="copy_icon" :style="{color: inviteUrl.length || disabled ? '#0277BD' : '#979797'}">
                content_copy
              </v-icon>
            </span>
            {{ adminText('workflowsAll.copy_aecf029', 'COPY') }}
          </button>
        </div>
      </div>
      <div class="badge_container">
        <div class="badge_container-left">
          <div class="badge_container-card-wrapper">
            <img :src="getBadgeImage" :alt="adminText('workflowsAll.qr_code_4474218', 'QR Code')">
          </div>
          <div class="badge_container-toggle">
            <div>
              <img src="/assets/sun_icon.svg" :alt="adminText('workflowsAll.light_a36ef8a', 'Light')">
            </div>
            <div>
              <v-switch
                v-model="invertBadgeColor"
                color="#0277BD"
              />
            </div>
            <div>
              <img src="/assets/moon_icon.svg" :alt="adminText('workflowsAll.dark_ae1ef01', 'Dark')">
            </div>
          </div>
        </div>
        <div class="badge_container-right">
          <p>
            {{ workflowLabel(workflowCustomerLabel('invitePageQrCodeDescription', {}, $t('invitePageQrCodeDescription'))) }}
          </p>
          <div>
            <div>
              <main-button
                class="qr-box"
                style="width: 100%; margin: 10px 0 0 0"
                :text="adminText('workflowsAll.download_qr_code_2112d52', 'Download QR Code')"
                outline
                :disabled="!inviteUrl.length"
                @click="downloadQr"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import QRCodeStyling from 'qr-code-styling'

export default {
  mixins: [WorkflowDisplay],
  name: 'attendee-invites',
  props: {
    form: {
      type: Object,
      required: true,
    },
    selectedLanguage: {
      type: String,
      required: true,
    },
    inviteUrl: {
      type: String,
      required: true,
    },
    eventId: {
      default: null,
      type: String,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    categoriesModule: {
      type: Boolean,
      default: false,
    },
    eventSlug: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onShowSnackbar', 'onSelectedLanguage'],
  data() {
    return {
      invertBadgeColor: false,
    }
  },
  computed: {
    getBadgeImage() {
      const color = this.invertBadgeColor ? 'black' : 'white'

      return `/assets/qr_code_badge_${color}_${this.selectedLanguage}.svg`
    },
  },
  methods: {
    openSnackbar() {
      this.$emit('onShowSnackbar', {
        open: true,
        message: 'workflowsAll.copied_to_clipboard_0e73834',
        color: 'primary',
      })
    },
    generateQRCode() {
      return new QRCodeStyling({
        width: 300,
        height: 300,
        type: 'svg',
        data: this.inviteUrl,
        image: '/assets/logos/logo-colored.svg',
        dotsOptions: {
          color: 'black',
          type: 'square',
        },
        backgroundOptions: {
          color: 'white',
        },
        imageOptions: {
          crossOrigin: 'anonymous',
        },
        options: {
          typeNumber: 1,
        },
      })
    },
    downloadBadge() {
      // TODO: implementation in another thicket
    },
    downloadQr() {
      const qrCode = this.generateQRCode()
      qrCode.append(document.getElementById('canvas'))
      qrCode.download({ name: 'qr', extension: 'png' })
    },
  },
}
</script>

<style scoped>
.el_tabs button {
  border: 1px solid #D9D9D9;
  padding: 0 20px;
  appearance: none;
  border-radius: 10px 10px 0 0;
  background-color: #F5F5F5;
  color: #666666;
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 38px;
  font-weight: 700;
  gap: 5px;
}

.el_tabs button.active {
  background-color: white;
  color: #0277BD;
  font-weight: 700;
  border-bottom: 0;
  top: 2px;
  height: 40px;
}

.el_card {
  background-color: white;
  border: 1px solid #D9D9D9;
  width: 100%;
  max-width: 488px;
  border-radius: 0 10px 10px 10px;
  padding: 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
}

.el_card p {
  color: #979797;
  margin: 0;
  padding: 0;
}

.el_card .copy {
  padding: 10px 15px;
  background: #E6F1F8;
  color: #0277BD;
  display: flex;
  align-items: center;
  gap: 20px;
  border-radius: 10px;
}

.el_card .copy div:nth-child(2) {
  flex: 1 0 0;
}

.el_card .copy button {
  border: none;
  padding: 5px 15px;
  appearance: none;
  background-color: transparent;
  position: relative;
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  gap: 5px;
  color: #0277BD;
}

.copy_icon {
  flex: none !important;
  color: #0277BD
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.badge_container {
  display: flex;
  gap: 20px;
}

.badge_container-left {
  width: 180px;
  text-align: center;
}

.badge_container-left h5 {
  margin: 5px 0 0 0;
  padding: 0;
  font-size: 12px;
  font-weight: 400;
}

.badge_container-left h6 {
  margin: 5px 0 0 0;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
}

.badge_container-left img {
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: cover;
}

.badge_container-card-wrapper {
  position: relative;
  display: inline-block;
}

.badge_container-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.badge_container-right {
  flex: 1 0 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 0;
}

.badge_container-right p {
  color: #979797;
  margin: 0;
  padding: 0;
}

.link_icon_container {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 1280px) {
  .badge_container {
    flex-direction: column;
    align-items: center;
  }
}
</style>
